import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NachaRow } from '../../../models/nacha.model';

@Component({
  selector: 'app-nacha-confirm-create-ach-token-modal',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './confirm-create-ach-token-modal.component.html',
})
export class NachaConfirmCreateAchTokenModalComponent {
  @Input() data: any;

  get row(): NachaRow | null {
    return this.data?.data?.row ?? null;
  }

  get customerName(): string {
    return this.data?.data?.customerName ?? 'Customer';
  }

  maskAccount(account?: string): string {
    if (!account) return '****';
    const visible = account.slice(-4);
    const hidden = account.length > 4 ? '*'.repeat(account.length - 4) : '';
    return hidden + visible;
  }
}
